import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { AccountClient, GET_DYNAMIC_WIDGETS_META } from '@nile/graphql';
import { Loader, withErrorBoundary } from '@nile/components';
import { Widget } from './widget';
import { RuleConditionInput } from '@nile/types';

interface MetricSource {
  fieldName: string;
  argumentName: string;
  argumentType: string;
}

interface metricType {
  metricFunction: 'COUNT';
  attribute: string;
  metricSource?: MetricSource;
  filterCondition: RuleConditionInput;
}

interface TypeWidget {
  // name: string;
  icon: string;
  label: string;
  metric: metricType;
}

interface DynamicWidgetMeta {
  entity: string;
  widgets: TypeWidget[];
}

export const DynamicWidgets = withErrorBoundary(
  ({
    widgetGroup,
    additionalFilterConditions
  }: {
    widgetGroup: string;
    additionalFilterConditions?: RuleConditionInput[];
  }) => {
    const [dynamicWidgetMeta, setDynamicWidgetMeta] = useState<
      DynamicWidgetMeta
    >(null);

    const { loading } = useQuery(GET_DYNAMIC_WIDGETS_META, {
      fetchPolicy: 'network-only',
      client: AccountClient,
      skip: !widgetGroup,
      variables: {
        input: {
          widgetGroup
        }
      },
      onCompleted: (data) => {
        setDynamicWidgetMeta(data?.getDynamicWidgetsMeta || null);
      },
      onError: (error) => {
        console.error(error);
      }
    });

    return (
      <div className="pl-40 py-10 pr10 fx center g30 card-surface-bg scroll hideScrollBar">
        {loading ? (
          <div className="fx fw h80">
            <Loader />
          </div>
        ) : (
          dynamicWidgetMeta?.widgets.map((statistic) => {
            return (
              <div key={statistic.label}>
                <Widget
                  unitType={statistic.unitType}
                  label={statistic.label}
                  icon={statistic.icon}
                  metric={statistic.metric}
                  entity={dynamicWidgetMeta?.entity}
                  additionalFilterConditions={additionalFilterConditions}
                />
              </div>
            );
          })
        )}
      </div>
    );
  }
);
